<template>
      <!--
      	作者：fzf
      	时间：2025-06-28
      	描述：商品-商品素材
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="商品素材" name="material">
                    <Material v-if="activeName=='material'"></Material>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Material from './material/Index.vue';
    export default {
        components: {
            Material
        },
        data() {
          return {
              activeName: 'material',
              /*是否加载完成*/
              loading: true,
          }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/material3/index.vue